import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  TemplateRef,
  inject,
  type Type,
} from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import {
  DisplayGrid,
  GridType,
  Gridster,
  GridsterItem,
  type GridsterConfig,
} from 'angular-gridster2';
import { DynamicModule } from 'ng-dynamic-component';
import { IDashboardWidgetDetailDto } from '../models/widget.models';
import { WidgetTypeProvider } from '../services/widget-type.provider';
import { WidgetComponent } from '../widget/widget.component';

@Component({
    selector: 'bo-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        Gridster,
        GridsterItem,
        TranslocoModule,
        DynamicModule,
        WidgetComponent,
    ]
})
export class DashboardComponent {
  @HostBinding('class') class = 'bo-dashboard';

  private widgetTypeProvider = inject(WidgetTypeProvider);

  private _options: GridsterConfig = {
    gridType: GridType.Fit,
    displayGrid: DisplayGrid.OnDragAndResize,
    // minCols: 50,
    // minRows: 50,
    pushItems: true,
    draggable: {
      enabled: false,
    },
    resizable: {
      enabled: false,
    },
    // scale: 1,
    // margin: 1,
  };

  @Input()
  public set options(value: GridsterConfig) {
    if (value) {
      this._options = { ...this._options, ...value };
    }
  }

  public get options(): GridsterConfig {
    return this._options;
  }

  @Input()
  public widgets: Array<IDashboardWidgetDetailDto> = [];

  @Input()
  public headerTemplate?: TemplateRef<unknown>;

  //public addWidget(): void {}

  public getWidgetComponent(widget: IDashboardWidgetDetailDto): Type<unknown> | null {
    const typeValue = widget?.type;

    if (!typeValue) {
      return null;
    }

    if (typeof typeValue === 'string') {
      if (!this.widgetTypeProvider.isAvailable(typeValue)) {
        return null;
      }

      return this.widgetTypeProvider.getContentComponent(typeValue) as unknown as
        | Type<unknown>
        | null;
    }

    return typeValue as Type<unknown>;
  }
}
